import React from "react";
import { useIntl } from "react-intl";
import { SvBook } from "../graphql";

type TakeItemProps = {
  item?: SvBook;
};

export default function TakeItem({ item }: TakeItemProps) {
  const { formatMessage } = useIntl();

  return (
    <>
      {item !== undefined && (
        <>
          <h3 className="Title">
            <span>{formatMessage({ id: "hyvendor.column.bookinfo" })}</span>
          </h3>
          <section className="book-info">
            <div className="foto">
              <img src={item.photo} alt={item.title} />
            </div>
            <div className="info">
              <ul>
                <li className="book-title">
                  {formatMessage({ id: "hyvendor.column.title" })}
                  <span>{item.title}</span>
                </li>
                <li className="author">
                  {formatMessage({ id: "hyvendor.column.author" })}
                  <span>{item.author}</span>
                </li>
                <li className="publishing">
                  {formatMessage({ id: "hyvendor.column.publisher" })}
                  <span>
                    {item.publisher} {item.pub_date}
                  </span>
                </li>
                {item.edition && (
                  <li className="version">
                    {formatMessage({ id: "hyvendor.column.edition" })}
                    <span>{item.edition}</span>
                  </li>
                )}
                {item.intro && (
                  <li className="abstract">
                    {formatMessage({ id: "hyvendor.column.abstract" })}
                    <span>{item.intro}</span>
                  </li>
                )}
              </ul>
            </div>
          </section>
        </>
      )}
    </>
  );
}
